import React from 'react';
import { ANALYSIS_URL } from '../../Constatns';
import './Analytics.css'; 

const AnalyticsComponent = () => {
  return (
    <div className="outer-div">
       <div className="analytics-content">
        <iframe
          title="Field Force Analysis"
          src={ANALYSIS_URL}
          frameBorder="0"
          allowFullScreen={true}
          className="analytics-iframe"
        />
      </div>
    </div>
  );
};

export default AnalyticsComponent;
